import { useRef } from "react";

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { ChevronDown, ChevronUp, PlusLg, DashLg, XLg, PencilFill, ArrowUp, ArrowDown } from "react-bootstrap-icons";

export default function MyButton (props)
{
    const buttonRef = useRef(null);
    
    var icon;
    switch (props.icon)
    {
	case "edit" : icon = (<PencilFill/>); break;
	case "add" : icon = (<PlusLg/>); break;
	case "remove" : icon = (<DashLg/>); break;
	case "delete" : icon = (<XLg/>); break;
	case "newAmendment" : icon = (<PencilFill/>); break;
 	case "readMore" : icon = (<ChevronDown/>); break;
 	case "readLess" : icon = (<ChevronUp/>); break;
	case "up" : icon = (<ArrowUp/>); break;
	case "down" : icon = (<ArrowDown/>); break;
	default : icon = (<></>);
    }

    function handleClick ()
    {
	buttonRef.current.blur();
	props.onClick();
    }
    
    const button = (<Button variant={props.variant} size={props.size} ref={buttonRef} onClick={handleClick}>{icon}</Button>);
    if (props.tooltip === "") return button;
    
    return (
	<OverlayTrigger placement={props.placement} overlay={<Tooltip >{props.tooltip}</Tooltip>}>
	    {button}
	</OverlayTrigger>
    );
}

MyButton.defaultProps = {
    variant: "outline-primary",
    size: "sm",
    tooltip: "",
    placement: "top",
};
